module.exports = __webpack_public_path__ + "static/media/logo.477d3809.png";